import { render, staticRenderFns } from "./WCOOverall.vue?vue&type=template&id=8b3e1c50"
import script from "./WCOOverall.vue?vue&type=script&lang=js"
export * from "./WCOOverall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports